import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { generateReportFromRecords } from 'scenes/WorkDemo/utils/report-generation/generateReportFromRecords';
import { selectAssignmentsArray } from 'store/assignments/selectors/assignment.selectors';
import { returnAssignmentsWithFilledAssignmentNumberPath } from 'store/assignments/utils/returnAssignmentsWithFillerAssignmentNumberPath.util';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectProjectUsersArray } from 'store/projectUsers/selectors/projectUsers.selectors';
import {
  selectIsAutomaticMealBreakReductionsAppliedToRecordBasedReductions,
  selectIsRecordBasedReductionsActive,
} from 'store/reports/selectors/reports.selectors';
import { selectCurrentUserActiveEmployerProject } from 'store/resources/selectors/resources.selectors';
import {
  selectProjectsDataResourcesOfWorkCalendarRecords,
  selectWorkCalendarFilteredRecords,
  selectWorkCalendarProjectsArray,
} from '../../selectors/workSelectorsDemo';

export const generateReportFromWorkCalendarData = createAsyncThunk(
  'workCalendar/generateReportFromWorkCalendarData',
  async (dialogSettings, { getState }) => {
    const state = getState();

    const allWorkCalendarFilteredRecords =
      selectWorkCalendarFilteredRecords(state);

    const resources =
      selectProjectsDataResourcesOfWorkCalendarRecords(getState());

    const users = selectProjectUsersArray(getState());

    const assignments = selectAssignmentsArray(getState());

    const projects = selectWorkCalendarProjectsArray(getState());

    const utcOffset = moment.parseZone(moment().format()).format('Z');

    const isRecordBasedReductionsActive =
      selectIsRecordBasedReductionsActive(getState());

    const assignmentsWithFullAssignmentNumberPath =
      returnAssignmentsWithFilledAssignmentNumberPath(assignments);

    const selectedProject = selectSelectedProject(getState());

    const activeEmployerProject =
      selectCurrentUserActiveEmployerProject(getState());

    const isAutomaticMealBreakReductionsAppliedToRecordBasedReductions =
      selectIsAutomaticMealBreakReductionsAppliedToRecordBasedReductions(
        getState()
      );

    const automaticMealBreakReductionLengthMinutes =
      activeEmployerProject?.automaticMealBreakReductionLengthMinutes
        ? activeEmployerProject.automaticMealBreakReductionLengthMinutes
        : 30;

    const automaticMealBreakReductionLengthHours =
      automaticMealBreakReductionLengthMinutes / 60;

    const {
      selectedReportType,
      workStartTime,
      workEndTime,
      fromDate,
      toDate,
      language,
      filetype,
      workHourType,
      isDetailedReportSelected,
      paidCoffeeBreakMinutes,
    } = dialogSettings;

    const generationParams = {
      fromDate,
      toDate,
      selectedReportType,
      workStartTime,
      workEndTime,
      language,
      filetype,
      utcOffset,
      workHourType,
      isDetailedReportSelected,
      isRecordBasedReductionsActive,
      paidCoffeeBreakMinutes,
      automaticMealBreakReductionLengthHours,
      isAutomaticMealBreakReductionsAppliedToRecordBasedReductions,
    };

    const report = await generateReportFromRecords(
      allWorkCalendarFilteredRecords,
      resources,
      assignmentsWithFullAssignmentNumberPath,
      users,
      generationParams,
      projects,
      selectedProject
    );

    return report;
  }
);
